import { CmsIcons } from '@redteclab/api/clients/content-management-system'
import classNames from 'clsx'
import type { VFC } from 'react'

import { ICON_TO_COMPONENT_MAP } from 'views/components/atoms/Icon/consts'
import ButtonBlockMenu from 'views/components/molecules/ButtonBlockMenu'
import ErxDecorator from 'views/components/organisms/CmsMobileMenu/ErxDecorator'
import { getTagsFromString } from 'views/components/organisms/CmsMobileMenu/helpers'
import type { ItemProps } from 'views/components/organisms/CmsMobileMenu/types'

const Item: VFC<ItemProps> = props => {
  const {
    children,
    goNextHandler,
    hasErxAnnouncement,
    href,
    icon,
    name,
    tags,
    type,
  } = props
  const availableTags = getTagsFromString(tags || [])

  const hasChildren = availableTags?.expandable

  const onClickHandler =
    goNextHandler && hasChildren
      ? goNextHandler('', href, { fetchByPath: true })
      : null

  const itemProps = {
    ghost: availableTags?.ghost || false,
    hasChildren,
    href,
    isReactControlled: true,
    light: true,
    name,
    onClick: onClickHandler,
    type: type || 'button',
  }

  // get the Icon component
  const Icon = icon ? ICON_TO_COMPONENT_MAP[icon] : null

  return (
    <ButtonBlockMenu {...itemProps}>
      {Icon && (
        <Icon
          className={classNames('u-margin-xx-small--right', {
            'u-color--red': icon === CmsIcons.Redpoints,
          })}
        />
      )}
      <span className="l-flex__grow-one">{children}</span>
      {hasErxAnnouncement && <ErxDecorator />}
    </ButtonBlockMenu>
  )
}

Item.defaultProps = {
  hasErxAnnouncement: false,
  href: null,
  name: '',
  type: null,
}

export default Item
